import ERC20 from '@/infra/abis/ERC20.json';
import { numWei } from '@/composables/useFormatCurrency';
export default async function getTVL({ web3 }, BLIDPrice, BLIDTokenAddress, contractAddress) {
    const contract = new web3.eth.Contract(ERC20.abi, BLIDTokenAddress);
    const balanceOfMaster = await contract.methods.balanceOf(contractAddress).call();
    return numWei(balanceOfMaster) * BLIDPrice;
}
